var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"5","height":"18","rx":"1","fill":"currentColor","key":0}),React.createElement("rect",{"x":"9","width":"5","height":"18","rx":"1","fill":"currentColor","key":1})]);
}

Pause.defaultProps = {"width":"14","height":"18","viewBox":"0 0 14 18","fill":"none"};

module.exports = Pause;

Pause.default = Pause;
